import { render, staticRenderFns } from "./AirTransport.vue?vue&type=template&id=7b60ccfe&scoped=true&"
import script from "./AirTransport.vue?vue&type=script&lang=js&"
export * from "./AirTransport.vue?vue&type=script&lang=js&"
import style0 from "./AirTransport.vue?vue&type=style&index=0&id=7b60ccfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60ccfe",
  null
  
)

export default component.exports